import { render, staticRenderFns } from "./ReportPanel.vue?vue&type=template&id=227396f3&scoped=true&"
import script from "./ReportPanel.vue?vue&type=script&lang=js&"
export * from "./ReportPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReportPanel.vue?vue&type=style&index=0&id=227396f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227396f3",
  null
  
)

export default component.exports